"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
const index_1 = require("../../icons/index");
const index_2 = require("../index");
const SignaturePad = ({ hideClearButtonOnEmptyCanvas = true, onChange }) => {
    const canvas = (0, react_1.useRef)(null);
    const [isEmpty, setIsEmpty] = (0, react_1.useState)(true);
    const onEnd = () => {
        if (canvas?.current) {
            onChange(canvas.current?.toDataURL());
            setIsEmpty(canvas?.current.isEmpty());
        }
        else {
            throw new Error('unable to find canvas ref');
        }
    };
    return (react_1.default.createElement(index_2.Box, { position: "relative" },
        react_1.default.createElement(index_2.Box, { sx: { backgroundColor: 'grey.100' }, p: 1 },
            react_1.default.createElement(react_signature_canvas_1.default, { ref: canvas, onEnd: onEnd, canvasProps: { style: { width: '100%', height: '100% ', backgroundColor: '#fff' } } })),
        !(hideClearButtonOnEmptyCanvas && isEmpty) && (react_1.default.createElement(index_2.Button, { endIcon: react_1.default.createElement(index_1.Close, null), variant: "text", onClick: () => {
                if (canvas?.current) {
                    canvas.current.clear();
                    onChange(undefined);
                    setIsEmpty(true);
                }
            }, sx: { position: 'absolute', top: 8, right: 16 } }, "Clear"))));
};
exports.default = SignaturePad;
